import { Denomination } from "./Denomination";
import { CashTypeEnum } from "./enums/CashTypeEnum";

export class CashDetail {
    /** Denomination */
    denomination: Denomination = null;

    /** Quantity */
    quantity: number = 0;

    public get total(): number {
        return this.denomination.value * this.quantity;
    }

    public parse(obj: any) {
        if (obj.Denomination) {
            this.denomination = new Denomination();
            this.denomination.parse(obj.Denomination);
        }
        if (obj.Quantity) this.quantity = obj.Quantity;
    }

    static sort(arr: CashDetail[]) {
        arr.sort((a, b) => {
            if (a.denomination.currency != b.denomination.currency) {
                return a.denomination.currency.localeCompare(b.denomination.currency);
            }

            if (a.denomination.value != b.denomination.value) {
                return a.denomination.value - b.denomination.value;
            }

            if (a.denomination.revision != b.denomination.revision) {
                return a.denomination.revision.localeCompare(b.denomination.revision);
            }

            if (a.denomination.type != b.denomination.type) {
                if (a.denomination.type == CashTypeEnum.Banknote) return -1;
                else return +1;
            }

            if (a.quantity != b.quantity) {
                return a.quantity - b.quantity;
            }

            return 0;
        });
    }
}
